module.exports = __webpack_public_path__ + "static/SE-Collab-3-169c801692e6a523c34ae0ae1cca279b.png";